<template><!-- svgo-optimised -->
<svg class="icon" viewBox="0 0 14.78 18.29" xmlns="http://www.w3.org/2000/svg">
  <path fill="none" stroke="#ffffff" stroke-miterlimit="10" d="M0.5 0.5h4.87v17.29H0.5z" rx=".16" ry=".16"/>
  <path fill="none" stroke="#ffffff" stroke-miterlimit="10" d="M9.41 0.5h4.87v17.29H9.41z" rx=".16" ry=".16"/>
</svg></template>